<div class="form-page">
    <div class="steps-grafic">
        <app-registry-steps-grafic></app-registry-steps-grafic>
    </div>
    <div class="text-container-right">
        <router-outlet></router-outlet>
    </div>
</div>